<script setup>
import {ref, watch} from "vue";
import GroupedButtons from "../GroupedButtons.vue";

const emit = defineEmits(['step', 'change']);
const {value, pass} = defineProps(['value', 'pass']);

const selected_dance_access = ref(value.dance ?? 1);
const selected_fitness_access = ref(value.fitness ?? 1);
const selected_times = ref(selected_dance_access.value + selected_fitness_access.value);

const dance_access = {'1': 'Une séance', '2': 'Deux séances', '3': 'Trois séances'};
const fitness_access = {'1': 'Une séance', '2': 'Deux séances', '3': 'Trois séances', '4': 'Quatre séances'};

const formula = ref( pass.find( formula => formula.times === selected_times.value ) );

function next() {
    emit('step', 'special-courses');

    emit('change', {
        dance: selected_dance_access.value,
        fitness: selected_fitness_access.value,
    });
}

watch( selected_dance_access, nbr_access => selected_times.value = selected_fitness_access.value + nbr_access );
watch( selected_fitness_access, nbr_access => {
    if ( nbr_access === 4 ) {
        selected_dance_access.value = 1;
    } else if ( nbr_access === 3 ) {
        selected_dance_access.value = 2;
    }

    selected_times.value = selected_dance_access.value + nbr_access;
} );
watch( selected_times, nbr_access => formula.value = pass.find( formula => formula.times === nbr_access ) );
</script>

<template>
    <div class="flex flex-col">
        <div class="flex flex-col lg:flex-row mb-10">
            <div class="mb-10 lg:mb-0">
                <button class="button-invert px-5 py-2" type="button" @click="emit('step', 'previous')"><i class="fa-solid fa-angle-left | mr-2"></i> Retour</button>
            </div>
            <h2 class="text-white text-4xl text-center lg:w-10/12">Choix de la formule</h2>
        </div>

        <div class="flex flex-col mb-5">
            <div class="text-xl text-center text-white mb-5">Combien de séances de <span class="uppercase border-b">danse</span> par semaine ?</div>
            <grouped-buttons class="w-full lg:w-6/12 mx-auto" :class="{
                'pointer-events-none opacity-50': selected_fitness_access >= 3,
            }" @input="value => selected_dance_access = parseInt( value )" :value="selected_dance_access.toString()"
               :choices="dance_access"></grouped-buttons>
        </div>

        <p class="text-white text-center text-base mb-10 opacity-0 transition-opacity w-full lg:w-6/12 mx-auto md:px-12 lg:px-24"
            :class="{
                'opacity-100': selected_fitness_access >= 3,
            }"
        >
            Il n'est possible de prendre l'option <span class="italic">{{ selected_fitness_access }} séances de fitness</span> par semaine uniquement avec l'option <span class="italic">{{ selected_fitness_access === 3 ? 2 : 1 }} séances de danse</span> par semaine.
        </p>

        <div class="flex flex-col mb-20 lg:mb-10">
            <div class="text-xl text-center text-white mb-5">Combien de séances de <span class="uppercase border-b">fitness</span> par semaine ?</div>
            <grouped-buttons class="w-full lg:w-6/12 mx-auto" @input="value => selected_fitness_access = parseInt( value )"
                             :value="selected_fitness_access.toString()" :choices="fitness_access"></grouped-buttons>
        </div>

        <div class="text-white text-xl font-bold text-center mb-10">
            {{ formula.times }} séances / semaine<br/>
            {{ formula.price }} &euro; / SAISON
        </div>

        <div class="text-center">
            <button class="button px-5 py-3" type="button" @click="next">Suivant <i class="fa-solid fa-angle-right | ml-2"></i></button>
        </div>
    </div>
</template>